import React, { memo, useMemo, useState, Fragment } from 'react';
import { DropdownToggle, DropdownMenu, Dropdown } from 'reactstrap';

export interface MoreMenuItem {
  title: string;
  divider?: boolean;
  icon?: string;
  onClick?: () => void;
  disabled?: boolean;
  visible?: boolean;
  className?: string;
  loader?: boolean;
  alwaysOpen?: boolean;
}

export interface MoreMenuProps extends React.HTMLProps<HTMLDivElement> {
  vertical?: boolean;
  items: MoreMenuItem[];
  noItemsView?: React.ReactNode;
}

export const MoreMenu = memo((props: MoreMenuProps) => {
  const { items, vertical = false, ...rest } = props;
  const filtertedItems = useMemo(() => items.filter(i => i.visible !== false), [items]);
  const [isOpen, setOpen] = useState(false);

  if (filtertedItems.length === 0 && props.noItemsView) return <div {...rest}>{props.noItemsView}</div>;
  return (
    <div {...rest}>
      <Dropdown isOpen={isOpen} toggle={() => setOpen(!isOpen)}>
        <DropdownToggle
          tag="span"
          className="font-size-16 d-flex justify-content-center align-items-center"
          style={{ cursor: 'pointer' }}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {!props.children && (
            <Fragment>
              {!vertical && <i className="bx bx-dots-horizontal-rounded"></i>}
              {vertical && <i className="bx bx-dots-vertical-rounded"></i>}
            </Fragment>
          )}
          {props.children}
        </DropdownToggle>

        <DropdownMenu container="body" className="dd-menu_outside">
          {filtertedItems.map((item, index) => {
            if (item.divider) return <div key={index} className="dropdown-divider"></div>;
            return (
              <a
                key={index}
                onClick={e => {
                  if (item.alwaysOpen) {
                    setOpen(true);
                  } else {
                    setOpen(false);
                  }
                  item.onClick && item.onClick();
                }}
                className={`dropdown-item ${item.disabled ? 'disabled' : ''} ${item.className}`}
              >
                {item.icon && <i className={`${item.icon} mr-2`}></i>}
                {item.title}
                {item.loader && (
                  <Fragment>
                    <span className="content">
                      <span className="contentOriginal"></span> <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>{' '}
                    </span>
                  </Fragment>
                )}
              </a>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
});
